/* Colors */
export const COLOR_DECAYS = '#ff0000';
export const COLOR_OXYGEN = '#E67E22';

/* Option values */
export const OPTION_DRAW_DECAY_POINTS = 1;
export const OPTION_DRAW_DECAY_POINTS_SOURCE = 2;
export const OPTION_THEMES = {light: {O: COLOR_OXYGEN, DECAY: COLOR_DECAYS}};
